import AppHeader from './AppHeader'
import enhance from './AppHeader.enhancer'

export default enhance(AppHeader)



// WEBPACK FOOTER //
// ./src/containers/core/AppHeader/index.js